/**
 * Encodes a file into base64
 * @param file File object
 * @returns Base64 representation of the file
 */
export const toBase64 = async (file: File) =>
  new Promise<string | undefined>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result?.toString());
    reader.onerror = (error) => reject(error);
  });
